import { ConfigProvider, App as AntApp, theme } from 'antd';
import { RouterProvider } from 'react-router/dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import ruRU from 'antd/locale/ru_RU';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { router } from './routes';
import { useUIStore } from './stores/uiStore';
import { lightTheme, darkTheme } from './styles/theme';
import { queryClient } from './lib/queryClient';
import { initMessageService } from './services/messageService';
import './i18n/config';

// FLOW[27263]: MS229 - Inner component to initialize message service with App context
function AppContent() {
  const { message, notification, modal } = AntApp.useApp();

  useEffect(() => {
    initMessageService(message, notification, modal);
  }, [message, notification, modal]);

  return <RouterProvider router={router} />;
}

function App() {
  const { themeMode, language } = useUIStore();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeMode);
    document.documentElement.style.colorScheme = themeMode;
  }, [themeMode]);

  // FLOW[46114]: dayjs-локаль синхронна языку приложения — иначе DatePicker с
  // format="MMMM YYYY" показывал английские месяцы (ConfigProvider локализует
  // только тексты antd, а рендер дат делает dayjs со своей глобальной локалью).
  useEffect(() => {
    dayjs.locale(language === 'ru' ? 'ru' : 'en');
  }, [language]);

  const currentTheme = themeMode === 'dark' ? darkTheme : lightTheme;
  const locale = language === 'ru' ? ruRU : enUS;

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          ...currentTheme,
          algorithm: themeMode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
        }}
        locale={locale}
      >
        <AntApp>
          <AppContent />
        </AntApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
